<template>
  <div>
    <ReportHeader
      :key="reportType"
      :controls="controls"
      :controlsInitialValues="controlsInitialValues"
      :description="description"
      :hasExportableType="hasExportableType"
      :isLoadingExport="isLoadingExport"
      :reportType="reportType"
      :showLastUpdatedLabel="showLastUpdatedLabel"
      :title="title"
      @onExport="onExport()"
      @onPrint="onPrint()"
    />
    <div class="report-content">
      <template v-for="(section, index) in sections">
        <div :key="section.title + index" class="report-section mb-8">
          <Section
            :section="section"
            :data-tourid="`report-section-${index + 1}`"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ReportHeader from '@/containers/ReportsView/ReportHeader.vue'
import Section from '@/containers/ReportsView/Section.vue'

const REPORT_TYPES = {
  revsOverview: 'overview',
  validatedImpacts: 'validated_impacts',
  nonValidatedImpacts: 'non_validated_impacts',
  routinesOverview: 'routines_overview',
  routines: 'routines',
  quickActions: 'quick_action',
  improvementIdeas: 'improvement_idea',
  problemSolving: 'problem_solving',
  tasks: 'tasks',
  userActivityInRevs: 'users',
  global: 'global',
  teams: 'teams',
  challenges: 'challenges',
}

export default {
  name: 'Report',

  components: {
    ReportHeader,
    Section,
  },

  props: {
    showLastUpdatedLabel: Boolean,
    report: {
      type: Object,
      required: true,
    },
    controls: {
      type: Array,
      required: false,
      default: () => [],
    },
    controlsInitialValues: {
      type: Object,
      required: false,
      default: () => {},
    },
    isLoadingExport: {
      type: Boolean,
      required: true,
    },
    hasExportableType: {
      type: Boolean,
      required: false,
    },
    reportType: {
      type: String,
      required: false,
    },
  },

  computed: {
    title() {
      return this.report?.name ?? ''
    },

    sections() {
      return this.report?.sections ?? []
    },

    description() {
      switch (this.reportType) {
        case REPORT_TYPES.revsOverview:
          return this.$t('insights.report_descriptions.revs_overview')
        case REPORT_TYPES.validatedImpacts:
          return this.$t('insights.report_descriptions.validated_impacts')
        case REPORT_TYPES.nonValidatedImpacts:
          return this.$t('insights.report_descriptions.non_validated_impacts')
        case REPORT_TYPES.routinesOverview:
          return this.$t('insights.report_descriptions.routines_overview')
        case REPORT_TYPES.routines:
          return this.$t('insights.report_descriptions.routines')
        case REPORT_TYPES.quickActions:
          return this.$t('insights.report_descriptions.quick_actions')
        case REPORT_TYPES.improvementIdeas:
          return this.$t('insights.report_descriptions.improvement_ideas')
        case REPORT_TYPES.problemSolving:
          return this.$t('insights.report_descriptions.problem_solving')
        case REPORT_TYPES.tasks:
          return this.$t('insights.report_descriptions.tasks')
        case REPORT_TYPES.userActivityInRevs:
          return this.$t('insights.report_descriptions.user_activity_in_revs')
        case REPORT_TYPES.global:
          return this.$t('insights.report_descriptions.global')
        case REPORT_TYPES.teams:
          return this.$t('insights.report_descriptions.teams')
        case REPORT_TYPES.challenges:
          return this.$t('insights.report_descriptions.challenges')
        default:
          return ''
      }
    },
  },

  methods: {
    onExport() {
      return this.$emit('onExport')
    },

    onPrint() {
      return this.$emit('onPrint')
    },
  },
}
</script>

<style lang="scss" scoped>
.report-section:first-of-type {
  background-color: $color-white;
  border-top: 1px solid $color-blue-grey-lighten2;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
